import { FC } from 'react';
import 'twin.macro';
import 'styled-components/macro';

export interface CourseMetaProps {
  /** Title above unit */
  label: string;
  /** Unit */
  number: number;
  /** Subtitle after unit */
  unit?: string;
}

export const CourseMeta: FC<CourseMetaProps> = ({ label, unit, number, ...props }) => (
  <div {...props} tw="flex flex-col items-center bg-gray-5 rounded px-1 pt-2 pb-5 leading-snug text-center">
    <div tw="text-enlarged text-primary mb-4">{label}</div>
    <div tw="text-4xl font-bold text-gray-95 leading-none">{number}</div>
    {unit && <div tw="text-primary">{unit}</div>}
  </div>
);
